import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate"
import modules from "@/store/modules";
import Cookies from 'quasar/src/plugins/cookies/Cookies.js';;

/* Função para pegar o slug correto para a persistência da store */
function getCurrentSlug() {
  const pathParts = window.location.pathname.split('/').filter(Boolean);

  // Verifica se a rota é /login, /sign-up ou /save/token
  const specialRoutes = ['login', 'sign-up', 'save', 'token', 'redirect', 'recover'];
  if (pathParts.length >= 2 && specialRoutes.includes(pathParts[1])) {
    return pathParts[0]; // o slug vem antes da rota
  }

  // Para qualquer outra rota, pega do cookie
  return Cookies.get('slug');
}

export default createStore({
  modules: modules,
  plugins: [
    createPersistedState({
      key: `vuex-${getCurrentSlug()}`,
      paths: ['views.tour_presentations', 'auth.platform_access_records']
    })
  ]
});
